import { apiClient } from './client'

export interface NotificationsSummary {
  pendingRequests: number
}

export async function getNotificationsSummary(): Promise<NotificationsSummary> {
  const response = await apiClient.get<NotificationsSummary>('/admin/notifications/summary')
  return response.data
}
